import { apiRequest } from './client'

export type FeedbackCategory = 'bug' | 'suggestion' | 'experience' | 'other'
export type FeedbackStatus = 'pending' | 'rewarded' | 'rejected'

export interface SilkFeedback {
  id: number
  tenant_id: number
  user_id: number
  category: FeedbackCategory
  title: string
  content: string
  page_url?: string
  screenshot_urls?: string[]
  status: FeedbackStatus
  reward_points: number
  review_note?: string
  reviewed_at?: string
  created_at: string
}

export interface SilkFeedbackList {
  total: number
  items: SilkFeedback[]
}

export interface SilkFeedbackRewardHints {
  hints: Record<FeedbackCategory, number>
}

export interface CreateFeedbackBody {
  category: FeedbackCategory
  title?: string
  content: string
  page_url?: string
  screenshot_urls?: string[]
}

export const feedbackApi = {
  rewardHints: () =>
    apiRequest<SilkFeedbackRewardHints>('/api/v1/feedbacks/reward-hints', { auth: false }),

  create: (body: CreateFeedbackBody) =>
    apiRequest<SilkFeedback>('/api/v1/feedbacks', { method: 'POST', body }),

  myList: (params?: { status?: FeedbackStatus; category?: FeedbackCategory; limit?: number; offset?: number }) =>
    apiRequest<SilkFeedbackList>('/api/v1/feedbacks/me', { query: params }),
}
